module.exports = __webpack_public_path__ + "img/false-mark.2bcd8eef.svg";